<app-bar-chart-date
  i18n-header
  i18n-yNameRight
  header="Sales Invoices"
  xKey="invoiceDate"
  yKey="value"
  yKeyRight="numberOfInvoices"
  yNameRight="Number of Invoices"
  [service]="chartWeeksSalesInvoicesService"
  [xRotation]="xRotation"
  [yName]="yNameSalesValue"
  [id]="customerId"
  [barChartPeriod]="barChartPeriod"
>
</app-bar-chart-date>
